$(function () {
  //Sliders
  $('.Casestudies-slick').slick({
    slidesToShow: 1,
    dots: true,
    appendDots: $('.Slick-dots'),
    arrows: true,
    appendArrows: $('.Slick-box'),
    infinite: true,
    speed: 300,
    adaptiveHeight: false,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '160px',
    responsive: [{
      breakpoint: 1024,
      settings: {
        centerMode: false,
        centerPadding: '50px'
      } // breakpoint: 500,
      // settings: {
      //     centerMode: true,
      //     centerPadding: '0px'
      // }

    }]
  });
});